
import Formal from '../../../../../mixin/formal'
export default {
    name: 'GameFormalDanshi2',
    mixins: [Formal],
    data() {
        return {
            content: ''
        }
    },
    computed: {
        contentFilter() {
            return this.DanShiFilter(this.content)
        }
    },
    watch: {
        content(val) {
            if (val) {
                this.$emit('change', this.MakeOrder())
            }
        }
    },
    props: ['template', 'rank'],
    methods: {
        init() {
            this.Reset()
            for (let key of this.template.defaultCheckedPos) {
                this.digitDir[key].value = true
            }
        },
        Reset() {
            this.content = ''
        },
        Clean() {
            this.Reset()
        },
        Pick() {
            this.$refs.file.click()
        }
    },
    components: {

    },
    mounted() {
        this.init()
    }
}